module.exports = "<div class=\"lds-ellipsis\">\n    <div></div><div></div><div></div><div></div>\n</div>"